var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"section-title"},[_c('span',{staticClass:"section-title__accent",attrs:{"aria-hidden":"true"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }